import CloseIcon from '@mui/icons-material/Close';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import React from 'react';

interface AppDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  width?: number | string;
  children: React.ReactNode;
}

export const AppDrawer: React.FC<AppDrawerProps> = ({
  open,
  onClose,
  title,
  width = 480,
  children,
}) => {
  return (
    <Drawer anchor='right' open={open} onClose={onClose}>
      <Box sx={{ width, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 3,
            py: 2,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}>
          <Typography variant='h6'>{title}</Typography>
          <IconButton onClick={onClose} aria-label='close'>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ flex: 1, overflowY: 'auto', p: 3 }}>{children}</Box>
      </Box>
    </Drawer>
  );
};
